import React, { useMemo } from "react";
import {
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  IconButton,
  Stack,
  Rating,
  Box,
} from "@mui/material";

import { styles } from "./styles";

import { convertTimeIsoToUs } from "@/utils/globals";
import { IMapPois, IReviewPoi } from "@/types/pois";
import { ReactComponent as DockshareIcon } from "&/img/markers/pois/place/PrivateDock.svg";
import { ReactComponent as SnagASlipIcon } from "&/img/icons/AvatarSAS.svg";

interface IPlaceInfoReviewsListItem {
  review: IReviewPoi;
  poi: IMapPois;
}
function PlaceInfoReviewsListItem({ review, poi }: IPlaceInfoReviewsListItem) {
  const partnerType = useMemo(() => {
    if (poi?.snag_a_slip) return "snag_a_slip";
    if (poi?.dockshare) return "dockshare";

    return null;
  }, [poi]);

  const itemUsername =
    partnerType === "snag_a_slip"
      ? "Snag-A-Slip User"
      : partnerType === "dockshare"
      ? "Dockshare User"
      : `${review?.user?.first_name} ${review?.user?.last_name}`;

  const itemAvatar =
    partnerType === "dockshare" ? (
      <DockshareIcon height={40} width={40} />
    ) : partnerType === "snag_a_slip" ? (
      <SnagASlipIcon />
    ) : (
      <Avatar
        alt={`${review?.user?.first_name} ${review?.user?.last_name}`}
        src={review.user?.image}
        sx={styles.avatar}
      />
    );

  return (
    <Box component="li" sx={styles.li}>
      <ListItem component="div" sx={styles.listItem}>
        <ListItemAvatar>
          <IconButton sx={styles.iconButton}>{itemAvatar}</IconButton>
        </ListItemAvatar>
        <ListItemText
          primary={itemUsername}
          primaryTypographyProps={{
            component: "h4",
            variant: "subtitle2",
          }}
          secondary={
            <Stack direction="row" spacing={1}>
              <Rating
                readOnly
                defaultValue={review?.rating}
                name="rating-place"
                precision={0.5}
                size="small"
              />
              <Typography variant="caption">{convertTimeIsoToUs(review?.created_at)}</Typography>
            </Stack>
          }
          secondaryTypographyProps={{
            component: "div",
          }}
          sx={{ ml: 1.5 }}
        />
      </ListItem>
      <Box pb={1} px={2}>
        <Typography variant="body2">{review?.review}</Typography>
      </Box>
      {review?.reply && (
        <Box px={2} sx={{ borderLeft: "2px solid #E0E0E0", ml: 4 }}>
          <Typography variant="body2">
            <Typography sx={{ fontWeight: 600, display: "inline" }} variant="body2">
              Response:
            </Typography>{" "}
            {review?.reply}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default PlaceInfoReviewsListItem;
